import {
  UserSurveyPrimaryFunction,
  UserSurveyRole,
} from 'Generated/graphql-types'
import { IntakeFlowStep, Priority, priorityToParam } from './constants'

/**
 * Sends an analytics event when a user transitions between steps in the intake flow
 */
export const sendStepTransitionEvent = ({
  currentStep,
  nextStep,
  userId,
  nonprofitOrgId,
  funderOrgId,
  userEmail,
  userPrimaryFunction,
  userJourneyLength,
  userRole,
}: {
  currentStep: IntakeFlowStep
  nextStep: IntakeFlowStep
  userId: number
  nonprofitOrgId: number
  funderOrgId: number | null
  userEmail: string
  userPrimaryFunction: UserSurveyPrimaryFunction | undefined
  userJourneyLength: number
  userRole: UserSurveyRole | undefined
}) => {
  const stepTransitionData = {
    userId,
    nonprofitOrgId,
    funderOrgId,
    userEmail,
    currentStep,
    nextStep,
    userPrimaryFunction,
    userJourneyLength,
    userRole,
  }

  analytics.track(
    `Intake_Flow_${stepTransitionData.currentStep}_Step_Transition`,
    {
      // Include your event properties here
      // You can reuse the existing analytics schema or create a new one
      ...stepTransitionData,
      timestamp: new Date().toISOString(),
    }
  )
}

/**
 * Sends an analytics event when a user completes the intake flow
 */
export const sendIntakeCompletedEvent = ({
  userId,
  nonprofitOrgId,
  funderOrgId,
  userEmail,
  userPrimaryFunction,
  userRole,
  totalSteps,
  timeSpent,
}: {
  userId: number
  nonprofitOrgId: number
  funderOrgId: number | null
  userEmail: string
  userPrimaryFunction: UserSurveyPrimaryFunction | undefined
  userRole: UserSurveyRole | undefined
  totalSteps: number
  timeSpent?: number
}) => {
  const completionData = {
    userId,
    nonprofitOrgId,
    funderOrgId,
    userEmail,
    userPrimaryFunction,
    userRole,
    totalSteps,
    timeSpent,
    completedAt: new Date().toISOString(),
  }

  analytics.track('Intake_Flow_Completed', completionData)
}

/**
 * Helper function to create a map of impact areas for the intake flow
 */
export const createImpactAreasMap = (
  impactAreas: Array<{ id: string; name: string; description: string }> = []
) => {
  const impactAreasMap: Record<
    string,
    { id: string; name: string; description: string }
  > = {}

  impactAreas.forEach((area) => {
    impactAreasMap[area.id] = area
  })

  return impactAreasMap
}

export const prioritiesToAcademySearchLink = (priorities: Priority[]) => {
  const params = priorities.reduce<string[]>((acc, priority) => {
    const param = priorityToParam[priority]
    return acc.includes(param) ? acc : [...acc, param]
  }, [])

  return `/academy/all-resources?topics=${params.join(
    '%2C'
  )}&sortingCategory=createdAtDesc`
}
